import { useQuery } from '@tanstack/react-query';
import apiClient from '@shared/lib/apiClient';
export const useWhatsAppConfig = () => useQuery({
    queryKey: ['whatsapp', 'config'],
    queryFn: async () => {
        const { data } = await apiClient.get('/whatsapp/config');
        return data;
    },
    staleTime: 1000 * 60,
    retry: 1,
});
